import { render } from "./ReadOnlyPresetValue.vue?vue&type=template&id=47a17fd7&scoped=true&ts=true"
import script from "./ReadOnlyPresetValue.vue?vue&type=script&lang=ts"
export * from "./ReadOnlyPresetValue.vue?vue&type=script&lang=ts"

import "./ReadOnlyPresetValue.vue?vue&type=style&index=0&id=47a17fd7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47a17fd7"]])

export default __exports__